import { render } from "./SpliceVaultViewer.vue?vue&type=template&id=4a12b5c7&scoped=true"
import script from "./SpliceVaultViewer.vue?vue&type=script&lang=js"
export * from "./SpliceVaultViewer.vue?vue&type=script&lang=js"

import "./SpliceVaultViewer.vue?vue&type=style&index=0&id=4a12b5c7&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/RNAseq_web/prime_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a12b5c7"]])

export default __exports__